
import React, { createContext, useState, useEffect, useContext } from 'react';
import { NavLink } from 'react-router-dom';

const CookieContext = createContext();

export function CookieProvider({ children }) {
  const [showBanner, setShowBanner] = useState(true);
  const [cookiesShouldLoad, setCookiesShouldLoad] = useState(false);
  const [selectionHasBeenMade, setSelectionHasBeenMade] = useState(false);

  useEffect(() => {
    const cookieConsent = window.localStorage.getItem('cookieConsent');
    const sessionConsent = sessionStorage.getItem('cookieConsent');
    if (!cookieConsent && !sessionConsent) {
      setShowBanner(true);
    } else if (cookieConsent === 'all' || sessionConsent === 'all') {
      handleAcceptAll();
    } else if (cookieConsent === 'necessary' || sessionConsent === 'necessary') {
      handleAcceptNecessary();
    } else if (cookieConsent === 'rejected' || sessionConsent === 'rejected') {
      handleReject();
    }
    // eslint-disable-next-line
  }, []);

  const handleAcceptAll = () => {
    window.localStorage.setItem('cookieConsent', 'all');
    sessionStorage.removeItem('cookieConsent');
    setShowBanner(false);
    setCookiesShouldLoad(true);
    setSelectionHasBeenMade(true);
  };

  const handleAcceptNecessary = () => {
    window.localStorage.setItem('cookieConsent', 'necessary');
    window.localStorage.removeItem('cookieConsent');
    setShowBanner(false);
    setCookiesShouldLoad(false);
    setSelectionHasBeenMade(true);
  };

  const handleReject = () => {
    sessionStorage.setItem('cookieConsent', 'rejected');
    if (window.localStorage.getItem('cookieConsent') === 'all') {
      window.localStorage.removeItem('cookieConsent');
      window.location.reload();
    }
    setShowBanner(false);
    setCookiesShouldLoad(false);
    setSelectionHasBeenMade(true);
  };

  return (
    <CookieContext.Provider value={{
      showBanner,
      setShowBanner,
      selectionHasBeenMade,
      handleAcceptAll,
      handleAcceptNecessary,
      handleReject,
      cookiesShouldLoad
    }}>
      {cookiesShouldLoad && <GoogleAnalyticsTag />}
      {cookiesShouldLoad && <HotjarTag />}
      {children}
    </CookieContext.Provider>
  );
}

export function useCookies() {
  return useContext(CookieContext);
}

export function CookieBanner() {
  const { showBanner, handleAcceptAll, 
    handleAcceptNecessary, 
    handleReject, 
    setShowBanner, 
    selectionHasBeenMade } = useCookies();

  return (
    <>
      <style>
        {`
          .cookie-banner {
            background-color: #222;
            color: white;
            padding: 10px;
            padding-left: 5rem;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
            z-index: 1001;
            border-radius: 5px;
            margin: 0rem auto;
            text-align: center;
          }
          .cookie-banner button {
            margin: 0 4px;
            border-radius: 4px;
            border: none;
            padding: 6px 12px;
            font-weight: bold;
            cursor: pointer;
          }
          .cookie-banner a { color: #deb841; text-decoration: underline; }
        `}
      </style>
      {showBanner &&
        <div className="cookie-banner">
          <p>We use cookies for analytics. See <a href="/privacy">the Privacy Policy</a> for details. Please choose your preference:</p>
          <button style={{background: '#deb841', color: '#222'}} onClick={handleAcceptAll}>Accept All Cookies</button>
          <button style={{background: '#2e275a', color: 'white'}} onClick={handleAcceptNecessary}>Accept Necessary Cookies</button>
          <button style={{background: '#888', color: 'white'}} onClick={handleReject}>Reject All Cookies</button>
          {selectionHasBeenMade &&
            <button style={{background: '#444', color: 'white'}} onClick={() => setShowBanner(false)}>
              Hide Cookie Management
            </button>
          }
        </div>
      }
    </>
  );
}

const hotjartagcontent = `
    (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:5345593,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
`;

function HotjarTag() {
  useEffect(() => {
    const cookieConsent = window.localStorage.getItem('cookieConsent');
    if (cookieConsent !== 'rejected') {
      const script = document.createElement('script');
      script.innerHTML = hotjartagcontent;
      document.head.appendChild(script);
    }
  }, []);
  return null;
}

function GoogleAnalyticsTag() {
  useEffect(() => {
    const cookieConsent = window.localStorage.getItem('cookieConsent');
    if (cookieConsent !== 'rejected') {
      const script = document.createElement('script');
      script.src = "https://www.googletagmanager.com/gtag/js?id=G-CK8Z7M4GNM";
      script.async = true;
      document.head.appendChild(script);

      script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() { window.dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', 'G-CK8Z7M4GNM', {'anonymize_ip': true });
      };
    }
  }, []);
  return null;
}

// NavLink-style trigger button for sidebar
export function CookieManagerTriggerNavLink({onClick}) {
  const { setShowBanner } = useCookies();
  return (
    <NavLink
      to="/managecookies"
      style={{textDecoration: 'none',
                  fontFamily: 'Arial, sans-serif',
                  fontSize: '1.1rem'
      }}
      onClick={e => { 
        if (onClick) onClick(e);
        e.preventDefault(); 
        setShowBanner(true); 
        window.scrollTo(0, 0); }}
      className=""
    >
      Manage Cookies
    </NavLink>
  );
}